import React, { useEffect } from 'react';
// import Header from './Header'; // Removed this import
import Hero from './Hero';
import Info from './Info';
import FAQs from './FAQs';
// import Footer from './Footer';
import List from './List';
import FAQsMobile from './FAQsMobile';
import '../../assets/styles/homepage-v2.css';
import './HomeV2.css';
import { updateUserActivity } from '../../utils/api'; // Import our new function

const HomeV2 = () => {
  // Add a useEffect hook to update activity on component mount
  useEffect(() => {
    updateUserActivity(); // Fire-and-forget call
  }, []); // Empty dependency array ensures it runs only once

  return (
    <div className="homev2-root">
      {/* <Header />  Removed the V2-specific header instance */}
      <Hero />
      <Info />
      <FAQs />
      {/* <List /> component - to be decided if needed or where it belongs */}
      {/* <FAQsMobile /> component - to be decided if needed or can be merged */}
      {/* <Footer /> */}
    </div>
  );
};

export default HomeV2; 